import { FC } from 'react';
import { css } from '@emotion/react';
import { lighten } from 'polished';
import { ArrowRight, Spinner } from '@phosphor-icons/react';
import { ListItemFigure } from 'client/components/Other/ListItemFigure';
import { itemStyle } from 'client/components/RadioGroup/RadioGroupItem';
import { Typography } from 'client/components/Typography';
import githubLogo from 'client/static/image/github-logo-white.svg';
import { spinAnimation } from 'client/Theme';

const githubButtonStyle = css`
  width: 100%;
  background-color: black;

  &::after {
    content: none;
  }

  &:hover,
  &:disabled {
    background-color: ${lighten(0.2, '#000')} !important;
  }

  &:disabled {
    padding: 16px;
    border: none;
  }

  > section {
    flex: 1;

    .body1 {
      color: #fff;
    }

    .body2 {
      color: #fff;
      opacity: 0.7;
    }
  }

  > svg {
    color: #fff;
  }
`;

const spinnerStyle = css`
  animation: ${spinAnimation} 2s linear infinite;
`;

export interface LoginWithGitHubButtonProps {
  title?: string;
  loading: boolean;
  onClick: VoidFunction;
}

export const LoginWithGitHubButton: FC<LoginWithGitHubButtonProps> = ({ title = 'Authenticate with GitHub', loading, onClick }) => (
  <button css={[itemStyle, githubButtonStyle]} disabled={loading} onClick={onClick}>
    <ListItemFigure image={{ alt: 'github logo', src: githubLogo }} />
    <section>
      <Typography variant="body1" noWrap>
        {title}
      </Typography>
      <Typography variant="body2" noWrap>
        Authenticate using your GitHub account
      </Typography>
    </section>
    {!loading && <ArrowRight size={24} />}
    {loading && <Spinner size={24} css={spinnerStyle} />}
  </button>
);
